import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

export type BudgetProgressBarSize = "lg" | "md";

// notch = track height − 2×the template's tw-p-0.5 padding, offset = −notch/2 (centres it on the
// fill's trailing edge). Keep both in sync by hand if a new size variant is added — get it wrong
// and the notch clips or floats off the seam with no compiler error, only visible on manual QA.
const SIZE_CLASSES: Record<BudgetProgressBarSize, { track: string; notch: string }> = {
  lg: { track: "tw-h-3", notch: "tw-h-2 tw-w-2 tw--right-1" },
  md: { track: "tw-h-2", notch: "tw-h-1 tw-w-1 tw--right-0.5" },
};

/**
 * Status-coloured progress bar: colour is the persistent background, a white "empty" fill drains
 * in from the left as emptyPercent grows, and the seam gets a concave notch (a small circle
 * matching the background colour, sat on the fill's own trailing edge) instead of the fill's
 * corner bulging outward. Used for budget spend and days-remaining indicators.
 */
@Component({
  selector: "app-budget-progress-bar",
  templateUrl: "./budget-progress-bar.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: "tw-flex-1" },
})
export class BudgetProgressBarComponent {
  @Input() emptyPercent = 0;
  @Input() colorClass = "";
  @Input() size: BudgetProgressBarSize = "md";

  protected get sizeClasses(): { track: string; notch: string } {
    return SIZE_CLASSES[this.size];
  }
}
